import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function OrdenesCorteCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const ordenTallas = ["XCH", "CH", "M", "G", "XG", "7", "9", "11", "13"];

  const [articulos, setArticulos] = useState([]);
  const [articuloSel, setArticuloSel] = useState(null);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [grid, setGrid] = useState([]); // [{colores, colorNombre, tallas, tallaNombre, cantidad}]

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [numero, setNumero] = useState("NA");

  // Modal de captura por proporción
  const [modalProporcion, setModalProporcion] = useState(false);
  const toggleProporcion = () => setModalProporcion(!modalProporcion);
  const [colorProporcion, setColorProporcion] = useState("");
  const [totalProporcion, setTotalProporcion] = useState(0);
  const [proporciones, setProporciones] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setArticulos(res.data))
      .catch((err) => console.log(err));
  }, []); // eslint-disable-line

  // Al elegir un artículo, despliega sus colores y tallas en una rejilla
  function seleccionaArticulo(art) {
    setArticuloSel(art);
    if (!art) {
      setColores([]);
      setTallas([]);
      setGrid([]);
      return;
    }
    let cols = art.colores || [];
    let tals = art.tallas || [];
    setColores(cols);
    setTallas(tals);

    const nuevo = [];
    cols.forEach((c) => {
      tals.forEach((t) => {
        nuevo.push({
          colores: c._id,
          colorNombre: c.name,
          tallas: t._id,
          tallaNombre: t.name,
          cantidad: 0,
        });
      });
    });
    setGrid(nuevo);
  }

  function cambiaCantidad(idColor, idTalla, valor) {
    setGrid((prev) =>
      prev.map((g) =>
        g.colores === idColor && g.tallas === idTalla
          ? { ...g, cantidad: valor }
          : g
      )
    );
  }

  function abreProporcion(idColor) {
    setColorProporcion(idColor);
    setTotalProporcion(0);
    setProporciones(
      tallas.map((t) => ({ tallas: t._id, tallaNombre: t.name, proporcion: 0 }))
    );
    toggleProporcion();
  }

  function cambiaProporcion(idTalla, valor) {
    setProporciones((prev) =>
      prev.map((p) => (p.tallas === idTalla ? { ...p, proporcion: valor } : p))
    );
  }

  function aplicaProporcion() {
    let suma = proporciones.reduce(
      (t, p) => t + (parseFloat(p.proporcion) || 0),
      0
    );
    if (suma <= 0 || totalProporcion <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Captura el total y al menos una proporción.",
      });
      return;
    }
    setGrid((prev) =>
      prev.map((g) => {
        if (g.colores !== colorProporcion) return g;
        let prop = proporciones.find((p) => p.tallas === g.tallas);
        let p = prop ? parseFloat(prop.proporcion) || 0 : 0;
        let cant = Math.round((totalProporcion * p) / suma);
        return { ...g, cantidad: cant };
      })
    );
    toggleProporcion();
  }

  const totalPiezas = grid.reduce(
    (t, g) => t + (parseFloat(g.cantidad) || 0),
    0
  );

  const saveOrdenCorte = async (event) => {
    event.preventDefault();
    if (!articuloSel) {
      Swal.fire({ icon: "warning", title: "Selecciona un artículo" });
      return;
    }
    if (totalPiezas <= 0) {
      Swal.fire({ icon: "warning", title: "Captura cantidades a producir" });
      return;
    }
    setValidaBoton(false);
    toggleProgreso();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    try {
      // 1) Crea la orden de corte SIN pedido (producción directa)
      const data = await axios.post(
        URL_ORDENES_CORTE,
        {
          fecha,
          pedidos: "",
          cantidad: totalPiezas,
          observaciones,
          numero,
          cortado: "No",
          articulos: articuloSel._id,
          sinPedido: "Si",
          estado: "Pendiente Corte",
        },
        { headers }
      );

      const idOrden = data.data._id;
      const numeroOrden = `${data.data.numero || data.data.idOrdenesCorte || ""}`;

      // 2) Una línea de ArticulosOrdenesCorte por cada talla con cantidad > 0
      for (const g of grid) {
        if (parseFloat(g.cantidad) > 0) {
          await axios.post(
            URL_ARTICULOS_ORDENES_CORTE,
            {
              ordenesCorte: idOrden,
              articulos: articuloSel._id,
              colores: g.colores,
              tallas: g.tallas,
              cantidad: parseFloat(g.cantidad),
              pendiente_cortar: parseFloat(g.cantidad),
              cortado: 0,
              estado: "Pendiente Corte",
              numeroOrden,
            },
            { headers }
          );
        }
      }

      axios.post(
        URL_LOGS,
        { tipo: "Crear Orden de Corte", detalle: `${idOrden}`, user: user.id },
        { headers }
      );

      Swal.fire("Listo", `Orden de Corte ${numeroOrden} creada con éxito`, "success");
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    } catch (error) {
      toggleProgreso();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response ? error.response.data : ""}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      {user.menu_produccion ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cut" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Nueva Orden de Corte
              </h3>
              <p className="page-subtitle">
                Producción directa: selecciona artículo y captura cantidades a cortar
              </p>
            </div>
          </div>

          <Form onSubmit={saveOrdenCorte}>
            {/* Datos generales */}
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-cut" />
                <span className="form-section-title">Datos Generales</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={4}>
                    <Label>Artículo</Label>
                    <Autocomplete
                      size="small"
                      value={articuloSel}
                      onChange={(event, sel) => seleccionaArticulo(sel)}
                      options={articulos.sort((a, b) =>
                        (a.codigo || "") > (b.codigo || "") ? 1 : -1
                      )}
                      getOptionLabel={(option) =>
                        option ? `${option.codigo} ${option.descripcion || ""}` : ""
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona artículo" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fecha}
                      required
                      onChange={(e) => setFecha(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Número</Label>
                    <Input
                      type="text"
                      placeholder="Número"
                      value={numero}
                      onChange={(e) => setNumero(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      placeholder="Observaciones"
                      value={observaciones}
                      onChange={(e) => setObservaciones(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            {/* Captura por color y talla */}
            {articuloSel && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-list" />
                  <span className="form-section-title">Cantidades a Cortar</span>
                </div>
                <div className="form-section-body">
                  {colores.length === 0 || tallas.length === 0 ? (
                    <p style={{ color: "#94a3b8" }}>
                      El artículo necesita colores y tallas asignados.
                    </p>
                  ) : (
                    colores.map((col) => (
                      <div key={col._id} style={{ marginBottom: 14 }}>
                        <Row className="align-items-end">
                          <Col md={2}>
                            <strong>{col.name}</strong>
                            <br />
                            <Button
                              size="sm"
                              color="primary"
                              type="button"
                              style={{ marginTop: 4 }}
                              onClick={() => abreProporcion(col._id)}
                            >
                              <i className="fas fa-percentage" style={{ marginRight: 4 }} />
                              Proporción
                            </Button>
                          </Col>
                          {grid
                            .filter((g) => g.colores === col._id)
                            .sort((a, b) => {
                              const ia = ordenTallas.indexOf(a.tallaNombre);
                              const ib = ordenTallas.indexOf(b.tallaNombre);
                              return (ia === -1 ? Infinity : ia) - (ib === -1 ? Infinity : ib);
                            })
                            .map((g) => (
                              <Col md={1} key={g.tallas}>
                                <Label>{g.tallaNombre}</Label>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  value={g.cantidad}
                                  onChange={(e) =>
                                    cambiaCantidad(g.colores, g.tallas, e.target.value)
                                  }
                                />
                              </Col>
                            ))}
                        </Row>
                      </div>
                    ))
                  )}
                  <Row>
                    <Col md={12}>
                      <h4 style={{ marginTop: 10 }}>
                        TOTALES {new Intl.NumberFormat("en-US").format(totalPiezas)} pzas.
                      </h4>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            <div className="submit-bar">
              <Button
                href="/ListadoOrdenesCorte"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            </div>
          </Form>

          {/* Modal de captura por proporción */}
          <Modal isOpen={modalProporcion} toggle={toggleProporcion}>
            <ModalHeader toggle={toggleProporcion}>
              <i className="fas fa-percentage" style={{ marginRight: 8, color: "#3b82f6" }} />
              Captura por proporción
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label>Total a repartir</Label>
                  <Input
                    type="number"
                    min="0"
                    value={totalProporcion}
                    onChange={(e) => setTotalProporcion(parseFloat(e.target.value) || 0)}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                {proporciones.map((p) => (
                  <Col md={3} key={p.tallas} style={{ marginBottom: 8 }}>
                    <Label>{p.tallaNombre}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      value={p.proporcion}
                      onChange={(e) => cambiaProporcion(p.tallas, e.target.value)}
                    />
                  </Col>
                ))}
              </Row>
              <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: 8 }}>
                La cantidad de cada talla = Total × (proporción de la talla ÷ suma de
                proporciones).
              </p>
              <div className="submit-bar">
                <Button color="secondary" type="button" onClick={toggleProporcion}>
                  Cancelar
                </Button>
                <Button color="success" type="button" onClick={aplicaProporcion}>
                  Aplicar
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCorteCreate;
